import { useEffect, useState } from "react";
import * as C from "./crypto";

export const ART_STATUSES = [["available", "Available"], ["sold", "Sold"], ["nfs", "Not for sale"], ["commission", "Commission open"]];
export const ART_QUALITY = { standard: 2500, gallery: 4000 };
export const SECTION_LAYOUTS = [["list", "List"], ["grid", "Grid"], ["masonry", "Masonry"], ["single", "Single column"], ["path", "Course: Path"], ["library", "Course: Library"]];
export const DEFAULT_PRICE = "Price on request";
export const EMPTY_ART = { year: "", medium: "", size: "", status: "available", show_price: false, price: DEFAULT_PRICE, sold_mark: true, quality: "standard", story: "", inquire: true };

export const statusLabel = (v) => (ART_STATUSES.find(([k]) => k === v) || [])[1] || "";

export const parseArt = (raw) => {
  if (!raw) return { ...EMPTY_ART };
  try { return { ...EMPTY_ART, ...JSON.parse(raw) }; } catch { return { ...EMPTY_ART }; }
};

// Artwork details live in the item body as JSON, encrypted with the Beacon key when private.
export const useArt = (it, encKey) => {
  const [art, setArt] = useState(() => (it.enc ? null : parseArt(it.body)));
  useEffect(() => {
    let live = true;
    if (!it.enc) { setArt(parseArt(it.body)); return; }
    if (!encKey || !it.body) { setArt(it.body ? null : parseArt(null)); return; }
    C.decryptText(encKey, it.body, it.body_iv).then((p) => live && setArt(parseArt(p))).catch(() => live && setArt(parseArt(null)));
    return () => { live = false; };
  }, [it.enc, it.body, it.body_iv, encKey]);
  return art;
};

export const artLine = (art) => [art?.year, art?.medium, art?.size].filter(Boolean).join(" · ");

export const useCaption = (it, encKey) => {
  const [cap, setCap] = useState(it.enc ? "" : (it.caption || ""));
  useEffect(() => {
    let live = true;
    if (!it.enc) { setCap(it.caption || ""); return; }
    if (!encKey || !it.caption) { setCap(""); return; }
    C.decryptText(encKey, it.caption, it.caption_iv).then((p) => live && setCap(p)).catch(() => live && setCap(""));
    return () => { live = false; };
  }, [it.enc, it.caption, it.caption_iv, encKey]);
  return cap;
};
